import { Interpolation } from "@emotion/core";

const container: Interpolation = {
  position: "relative",
  overflow: "hidden",
};

const content: Interpolation = {
  width: "100%",
};

const styles = {
  container,
  content,
};

export default styles;
